import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/edit.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, _hoisted_2))
}